<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox">
        <p class="add-title">账户信息</p>
        <div class="write-txt name">
          <p class="write-title"><span>*</span>用户名：</p>
          <div class="write-text">
            <input type="text" v-model="user.name">
            <button class="btn btn-sub" @click="nameSub">修改</button>
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title"><span>*</span>手机号：</p>
          <div class="write-text">
            <input type="text" v-model="user.mobile" disabled style="cursor: no-drop;background-color: #CBCBCB;">
          </div>
        </div>
        
        <p class="add-title">修改密码</p>
        <div class="write-txt" v-if="user.is_password == 1">
          <p class="write-title"><span>*</span>当前密码：</p>
          <div class="write-text">
            <input type="text" v-model="passwordData.password">
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title"><span>*</span>新密码：</p>
          <div class="write-text">
            <input type="text" v-model="passwordData.password">
          </div>
        </div>
        <div class="write-txt">
          <p class="write-title"><span>*</span>确认密码：</p>
          <div class="write-text">
            <input type="text" v-model="passwordNew">
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserDetail,updateUserName ,updatePassword } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import cityJson from './../assets/json/city.json'
export default {
  name: "index",
  data() {
    return {
      navId:'7',
      childrenID:'7-1',
      token:'',
      url:'',
      user:'',
      passwordData:{
        old_password:'',
        password:''
      },
      passwordNew:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getUser();
    console.log(cityJson,'==cityJson==')
  },
  methods: {
    getUser(){
      var that = this;
      setTimeout(function(){
        that.user = that.$refs.myHeader.userData;
      },1000)
    },

    async saveSub(){
      var that = this;
      if(this.passwordNew != that.passwordData.password){
        that.$message('密码不一致！');
        return false;
      };
      if(this.passwordNew == ''){
        that.$message('请确认密码！');
        return false;
      }
      if(this.passwordData.password == ''){
        that.$message('请输入新密码！');
        return false;
      }
      try {
        const response = await updatePassword(this.passwordData,this.token);
        if(response.code == 200){
          that.$message('修改成功');
          window.location.reload()      
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async nameSub(){
      var that = this;
      try {
        const response = await updateUserName({name:this.user.name},this.token);
        if(response.code == 200){
          that.$message('修改成功');
          window.location.reload()      
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    }
  }
  
};
</script>
<style scoped>

  .add-title,
  .list-title{
    color: #333333;
    font-size: 24px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.btn-ai{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 18px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  margin-left: 20px;
}

.ai-msg{
  height: 50px;
  line-height: 50px;
  color: #777777;
  font-size: 20px;
  display: inline-block;
  margin-left: 20px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}

.MobelBox .name input{

}

.MobelBox .name input,
.MobelBox .name .btn-sub{
  display: inline-block;
  vertical-align: top;
}

.MobelBox .name .btn-sub{
  height: 50px;
  line-height: 50px;
  color: #6098F2;
  margin-left: 20px;
  font-size: 20px;
}



</style>



// WEBPACK FOOTER //
// src/accounts/index.vue